import {
    IProduct,
    IPlaceHolder,
    IDisclaimer,
} from "../../infrastructure/interfaces";
import * as React from "react";
import './ProductPreview.css';
import '../Products/styles/TypeProductBulletin.css';
import { placeholderTypes } from "src/infrastructure/placeholderTypes";
import PagePlaceholder from "src/components/Editor/components/CropPageView/common/PagePlaceholder";
import { productType, ProductType } from "src/infrastructure/ProductType";
import { createProductShelfImage } from "../Editor/components/CropPageView/Catalog/Components/PageLayout/PageLayout"
import TypeProduct from "../Products/TypeProduct";

export interface CreateProductProps {
    productType: ProductType;
    templateType: string;
    product: IProduct | null;
    productName: string;
    category: string;
    category_2?: string;
    group: string;
    positioningStatement: string;
    features: string;
    benefits: string;
    rates: string;
    activeIngredients?: string;
    analysis?: string;
    targetChemistries?: string;
    iconPath?: string;
    disclaimer_1?: IDisclaimer;
    disclaimer_2?: IDisclaimer;
    url?: string;
}

export interface CreateProductState {
}

export default class CreateProductModal extends React.Component<CreateProductProps, CreateProductState> {
    constructor(props: CreateProductProps) {
        super(props);

        this.state = {
        };
    }

    generateProductFromProps(): IProduct {
        var variableText = null;
        if ((this.props.activeIngredients != null) && (this.props.activeIngredients.length > 0)) {
            variableText = {
                title: "Active Ingredients",
                content: this.props.activeIngredients
            }
        } else if ((this.props.analysis != null) && (this.props.analysis.length > 0)) {
            variableText = {
                title: "Analysis",
                content: this.props.analysis
            }
        } else if ((this.props.targetChemistries != null) && (this.props.targetChemistries.length > 0)) {
            variableText = {
                title: "Target Chemstries",
                content: this.props.targetChemistries
            }
        }
        const product: IProduct = {
            type: this.props.productType,
            id: 1,
            published: false,
            name: this.props.productName,
            category: this.props.category,
            category_2: this.props.category_2,
            group: this.props.group,
            statement: this.props.positioningStatement,
            features: this.props.features,
            grower_benefits: this.props.benefits,
            rates: this.props.rates,
            country: "",
            active_ingredients: this.props.activeIngredients,
            analysis: this.props.analysis,
            target_chemistries: this.props.targetChemistries,
            icon: this.props.iconPath,
            logo: (this.props.product != null) ? this.props.product.logo : '',
            disclaimers: [this.props.disclaimer_1, this.props.disclaimer_2].filter((disclaimer) => disclaimer != null),
            templateType: this.props.templateType,
            variableText: variableText,
            imageArea: (this.props.product != null) ? this.props.product.imageArea : undefined,
            recomendation_1: (this.props.product != null) ? this.props.product.recomendation_1 : undefined,
            recomendation_2: (this.props.product != null) ? this.props.product.recomendation_2 : undefined,
            separator_1: "",
            separator_2: "",
            separator_3: "",
            url: this.props.url,
            comment: ""
        }
        return product;
    }
    generateProductPlaceholderFromProps(): IPlaceHolder {
        const product: IProduct = this.generateProductFromProps();

        const productPlaceholder: IPlaceHolder = {
            data: product,
            accepts: [],
            type: placeholderTypes.Product
        };

        return productPlaceholder;
    }

    renderBulletin() {
        const productPlaceholder = this.generateProductPlaceholderFromProps();

        return (
            <div className="product-live-preview">
                <div className="crop-page-box right Bulletin">
                    <div className="crop-page-view ">
                        <div>
                            <div className={`crop-cont ${this.props.category.replace(' ', '')}`}>
                                <div className={`Bulletin left crop-page-view-drop isDropped catalog-product ${this.props.templateType}`}>
                                    <PagePlaceholder
                                        removeProduct={() => { }}
                                        index={1}
                                        model={productPlaceholder}
                                        isEditorView={true}
                                        pageNumber={1}
                                        document={null}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderCatalog() {
        const productPlaceholder = this.generateProductPlaceholderFromProps();

        return (
            <div className="product-live-preview">
                <div className={`crop-cont`}>
                    <div className={`page-layout-container-left`}>
                        <div className="Catalog  left crop-page-view-drop isDropped catalog-product type3">
                            <PagePlaceholder
                                removeProduct={() => {}}
                                index={1}
                                model={productPlaceholder}
                                isEditorView={true}
                                pageNumber={2}
                                document={null}
                            />
                        </div>
                        <div className="catalog-page-side-container-left">
                            <div className="catalog-page-side">
                                <div className='catalog-page-category'>
                                    {createProductShelfImage(this.props.category, undefined)}
                                    <span className='catalog-page-category-contents'>{this.props.category}</span>
                                </div>
                            </div>
                            <div className='catalog-page-number'>
                                <span>2</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderBrochure() {
        return (
            <div className="product-live-preview brochure">
                <div className="Brochure  left crop-page-view-drop isDropped " data-pagenumber="2">
                    <div className="page-placeholder-container">
                        <div>
                            <TypeProduct
                                product = {this.generateProductFromProps()}
                            />
                        </div>
                    </div>
                </div>
            </div>
         );
    }

    render() {
        switch (this.props.productType.toUpperCase()) {
            case productType.Bulletin.toUpperCase():
                return this.renderBulletin();
            case productType.Catalog.toUpperCase():
                return this.renderCatalog();
            case productType.Brochure.toUpperCase():
                return this.renderBrochure();
            default:
                return <div></div>
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/ProductPreview/ProductPreview.tsx